const JWT_KEY = "jwtToken";
const USER_DETAILS_KEY = "userDetails";
const USER_ID_KEY = "userId";

export function getJwtToken() {
  return localStorage.getItem(JWT_KEY) || "";
}

export function setJwtToken(token) {
  if (token) {
    localStorage.setItem(JWT_KEY, token);
  } else {
    localStorage.removeItem(JWT_KEY);
  }
}

export function getUserDetails() {
  const raw = localStorage.getItem(USER_DETAILS_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setUserDetails(details) {
  if (details) {
    localStorage.setItem(USER_DETAILS_KEY, JSON.stringify(details));
  } else {
    localStorage.removeItem(USER_DETAILS_KEY);
  }
}

export function clearAuth() {
  localStorage.removeItem(JWT_KEY);
  localStorage.removeItem(USER_DETAILS_KEY);
  localStorage.removeItem(USER_ID_KEY);
}
